export class DensityOfPeoplefactor {
  transportModeTypeIndex: number = 0;
  rawValueIndex: number = 1;
  replaceChar: string = ",";
  replaceWithChar: string = ".";
  splitChar: string = ";";
  validTransportModes: string[];

  constructor(rawData: string[]) {
    // if any structure changes appear use below line for debug purpose!

    // rawData.forEach(element => {
    //   console.log("Content of lines for PlaceDensityOfPeopleFactor: ", element);
    // });

    // lines[0] and lines[1] are currently overhead, actual data starts with lines[3]
    // since there are only 3 transport modes currently we can extract them starting by lines[3]
    this.validTransportModes = [rawData[3], rawData[4], rawData[5]];
  }
  getTransportModeIdByTransportModeTypeString(transportModeType: string) {
    // for current values for mapping see db table transport mode
    switch (transportModeType) {
      // long distance transport
      case "FV":
        return 3;
      // regional public transport
      case "NV":
        return 2;
      // urban public transport
      case "UNV":
        return 1;
      default:
        console.error("Error matching transport mode type!");
    }
  }
}
